import LogRocket from 'logrocket'

export const shouldUseLogRocket = (percentChance: number) => {
    const random = Math.random()
    if (percentChance >= random) {
        // console.log("using logrocket");
        return true
    }
    // console.log("not using logrocket");
    return false
}

const actuallyUseLogRocket = (id, email) => {
    LogRocket.init('dgfgoi/fw')
    LogRocket.identify(id, {
        email: email,
    })
    console.log('logrocket initialized!')
}

export const maybeUseLogRocketAfterDelay = (
    id,
    email,
    delay,
    percentChance
) => {
    if (shouldUseLogRocket(percentChance)) {
        const random = Math.random()
        if (random < 0.05) {
            console.log('maybe using logrocket immediately')
            console.log('delaying logrocket')
            actuallyUseLogRocket(id, email)
        }
        console.log('maybe using logrocket in the future')
        setTimeout(() => {
            actuallyUseLogRocket(id, email)
        }, delay)
    }
}
